import { ArrowDown16, ArrowUp16 } from '@carbon/icons-react';
import React from 'react';

export default class SortIcon extends React.Component {
  render() {
    const { show, isOrderDescending } = this.props;
    if (!show) return null;
    return isOrderDescending ? <ArrowDown16 /> : <ArrowUp16 />;
  }
}